export const nuofang_api = "/nuofang-wz-api";
export const nuofang_gps_api = nuofang_api + "/gps";
export const nuofang_gf_api = nuofang_api + "/gf_api";
export const nuofang_jngrid_api = nuofang_api + "/api/wz_api_php";


// WEBPACK FOOTER //
// ./src/config/common.js